import React from 'react';
import LabelComposer from './LabelComposer';

const LabelPrintModal = ({ product, store, onClose }) => {
  if (!product) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-3 sm:p-4">
      <LabelComposer product={product} store={store} onClose={onClose} variant="modal" />
    </div>
  );
};

export default LabelPrintModal;
